const h = (l, a) => {
  const o = document.getElementById(a);
  let e = o?.querySelector("ul");
  return e || (e = document.createElement("ul"), e.style.display = "flex", e.style.flexDirection = "row", e.style.margin = "0", e.style.padding = "0", o?.appendChild(e)), e;
}, f = {
  id: "htmlLegend",
  afterUpdate(l, a, o) {
    const e = h(l, o.containerID);
    for (; e.firstChild; )
      e.firstChild.remove();
    const c = l?.options?.plugins?.legend?.labels?.generateLabels?.(l);
    c && c.forEach((i, y) => {
      const n = document.createElement("li");
      n.style.alignItems = "center", n.style.cursor = "pointer", n.style.display = "flex", n.style.flexDirection = "row", n.style.marginLeft = "10px", n.onclick = () => {
        const { type: p } = l.config;
        if (p === "pie" || p === "doughnut")
          l.toggleDataVisibility(y);
        else {
          const { datasetIndex: r } = i;
          typeof r == "number" && l.setDatasetVisibility(
            r,
            !l.isDatasetVisible(r)
          );
        }
        l.update();
      };
      const t = document.createElement("canvas");
      t.width = 25, t.height = 25;
      const d = t.getContext("2d");
      d && (d.fillStyle = i.fillStyle || "transparent", d.fillRect(0, 0, 25, 25), t.style.borderColor = String(i.strokeStyle), t.style.borderWidth = i.lineWidth + "px", t.style.display = "inline-block", t.style.height = "25px", t.style.marginRight = "10px", t.style.width = "25px");
      const s = document.createElement("p");
      s.style.color = String(i.fontColor), s.style.margin = "0", s.style.padding = "0", s.style.textDecoration = i.hidden ? "line-through" : "";
      const g = document.createTextNode(i.text);
      s.appendChild(g), n.appendChild(t), n.appendChild(s), e.appendChild(n);
    });
  }
};
export {
  f as default
};
//# sourceMappingURL=index.es165.js.map
